import { createDeferred as c } from "../../../../primitives/async/deferred/main.js";
import { isWatchlistUnsubscribeToken as l } from "../../../../primitives/reactive/watchlist/main.js";
import { boolOrTrue as d } from "../../../../utils/value/bool.js";
const m = async (e) => {
  const r = c(), t = r.promise, o = e.context.refreshing;
  let n, i, s = e.subscribe((f) => {
    if (l(f)) {
      r.resolve();
      return;
    }
    if (n ?? (n = e.context.refreshing), !e.context.refreshing) {
      if (d(e.context.isExpired) && (i ?? (i = !(o || n)))) {
        i = !1, e.refresh();
        return;
      }
      r.resolve();
    }
  });
  return t.finally(() => {
    s(), s = null;
  }), t;
};
export {
  m as default
};
